// Preload cache — stores main section HTML keyed by product handle
var _pfsCache = {};

class ProductFamilySelector {
  constructor(element) {
    this.container = element;
    element._pfsInstance = this;
    this.allOptions = element.querySelectorAll('[data-handle]');
    this.currentHandle = this.getCurrentHandle();
    this.isLoading = false;
    this.init();
    this.initSlider();
  }

  init() {
    this.allOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = option.dataset.handle;
        if (handle && handle !== this.currentHandle && !this.isLoading) {
          this.switchProduct(handle, option);
        }
      });
    });
  }

  getCurrentHandle() {
    return window.location.pathname.split('/products/')[1]?.replace(/\?.*/, '').replace(/\/$/, '') || '';
  }

  initSlider() {
    var active = this.container.querySelector('.pfs__option--active');
    if (active) {
      var options = this.container.querySelector('.pfs__options');
      if (options) options.classList.add('pfs__options--no-transition');
      this.updateSliderPosition(active);
      if (options) {
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            options.classList.remove('pfs__options--no-transition');
          });
        });
      }
    }
  }

  updateSliderPosition(target) {
    var options = this.container.querySelector('.pfs__options');
    if (!options || !target) return;
    options.style.setProperty('--slide-left', target.offsetLeft + 'px');
    options.style.setProperty('--slide-top', target.offsetTop + 'px');
    options.style.setProperty('--slide-width', target.offsetWidth + 'px');
    options.style.setProperty('--slide-height', target.offsetHeight + 'px');
  }

  // Preload main product section for sibling products after page is idle
  preloadFamilyProducts() {
    var self = this;
    this.allOptions.forEach(function(option) {
      var handle = option.dataset.handle;
      if (handle && handle !== self.currentHandle && !_pfsCache[handle]) {
        fetch('/products/' + handle + '?section_id=main-product')
          .then(function(r) { return r.ok ? r.text() : null; })
          .then(function(html) {
            if (html && html.length > 100) {
              _pfsCache[handle] = html;
            }
          })
          .catch(function() {});
      }
    });
  }

  async switchProduct(newHandle, clickedButton) {
    if (this.isLoading) return;
    this.isLoading = true;

    // Immediately slide the green pill to the clicked button
    var previousActive = this.container.querySelector('.pfs__option--active');
    if (previousActive) previousActive.classList.remove('pfs__option--active');
    clickedButton.classList.add('pfs__option--active');
    clickedButton.classList.add('pfs__option--loading');
    this.updateSliderPosition(clickedButton);

    try {
      var cachedMain = _pfsCache[newHandle];

      if (cachedMain) {
        // INSTANT: swap main product section from cache
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.replaceMainSection(cachedMain);
        this.activateInlineScriptsIn(document.getElementById('shopify-section-main'));

        // Re-init family selector immediately (it lives inside main)
        var newSelector = document.querySelector('[data-product-family-selector]');
        if (newSelector) new ProductFamilySelector(newSelector);

        // Re-init Shopify PaymentButton for the new product form
        if (window.Shopify && window.Shopify.PaymentButton) {
          try { window.Shopify.PaymentButton.init(); } catch (e) {}
        }
      }

      // Fetch full page for remaining sections (and as fallback if no cache)
      var response = await fetch('/products/' + newHandle);
      if (!response.ok) throw new Error('Fetch failed: ' + response.status);
      var html = await response.text();
      var parser = new DOMParser();
      var newDoc = parser.parseFromString(html, 'text/html');

      document.title = newDoc.title || document.title;
      window.history.pushState({ productHandle: newHandle }, '', '/products/' + newHandle);

      if (cachedMain) {
        // Only replace non-main sections — main is already swapped
        this.replaceNonMainSections(newDoc);

        // Activate scripts and dispatch events only on non-main sections
        document.querySelectorAll('#MainContent .shopify-section').forEach(function(section) {
          if (section.id === 'shopify-section-main') return;
          // Activate inline scripts in this section
          section.querySelectorAll('script').forEach(function(oldScript) {
            if (oldScript.src) return;
            if (oldScript.type && oldScript.type !== 'text/javascript' && oldScript.type !== '') return;
            var newScript = document.createElement('script');
            Array.from(oldScript.attributes).forEach(function(attr) {
              newScript.setAttribute(attr.name, attr.value);
            });
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.replaceChild(newScript, oldScript);
          });
          try {
            section.dispatchEvent(new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: section.id.replace('shopify-section-', '') }
            }));
          } catch (e) {}
        });

        // Re-init review widgets for below-fold sections
        if (typeof jdgm !== 'undefined') {
          try { if (jdgm.customWidgets) jdgm.customWidgets(); } catch (e) {}
        }
        if (window.looxReviews) {
          try { window.looxReviews.init(); } catch (e) {}
        }
      } else {
        // No cache — replace everything and do full reinit
        window.scrollTo({ top: 0, behavior: 'instant' });
        this.replaceSections(newDoc);
        this.activateInlineScripts();
        this.reinitialize(newHandle);
      }
    } catch (error) {
      console.error('Product switch failed:', error);
      clickedButton.classList.remove('pfs__option--active');
      clickedButton.classList.remove('pfs__option--loading');
      if (previousActive) {
        previousActive.classList.add('pfs__option--active');
        this.updateSliderPosition(previousActive);
      }
      this.isLoading = false;
    }
  }

  replaceMainSection(html) {
    var currentSection = document.getElementById('shopify-section-main');
    if (!currentSection) return;

    var temp = document.createElement('div');
    temp.innerHTML = html;
    var newSection = temp.firstElementChild;
    if (!newSection) return;

    // section_id=main-product returns id="shopify-section-main-product"
    // but the template key on the page is "main" — keep the original ID
    newSection.id = 'shopify-section-main';

    newSection.querySelectorAll('.scroll-trigger').forEach(function(el) {
      el.classList.add('scroll-trigger--cancel');
    });
    currentSection.replaceWith(newSection);
  }

  replaceNonMainSections(newDoc) {
    var currentMain = document.getElementById('MainContent');
    var newMain = newDoc.getElementById('MainContent');
    if (!currentMain || !newMain) return;

    // Map current sections by ID
    var currentSections = {};
    currentMain.querySelectorAll(':scope > .shopify-section').forEach(function(el) {
      currentSections[el.id] = el;
    });

    // Collect new section IDs before adopting (adoptNode removes from source)
    var newSectionList = Array.from(newMain.querySelectorAll(':scope > .shopify-section'));
    var newSectionIds = new Set(newSectionList.map(function(el) { return el.id; }));

    // Replace or add non-main sections
    newSectionList.forEach(function(newSection) {
      if (newSection.id === 'shopify-section-main') return;
      var adopted = document.adoptNode(newSection);
      adopted.querySelectorAll('.scroll-trigger').forEach(function(el) {
        el.classList.add('scroll-trigger--cancel');
      });
      var existing = currentSections[adopted.id];
      if (existing) {
        existing.replaceWith(adopted);
      } else {
        currentMain.appendChild(adopted);
      }
    });

    // Remove sections that only exist in the old template
    Object.keys(currentSections).forEach(function(id) {
      if (id === 'shopify-section-main') return;
      if (!newSectionIds.has(id) && currentSections[id].parentNode) {
        currentSections[id].remove();
      }
    });

    // Judge.me delivers reviews pre-rendered but hidden behind
    // display:none wrappers and a temp-hiding <style> tag.
    // Their entry point script normally removes these on page load,
    // but doesn't re-run after AJAX. Unhide them manually.
    this.reinitJudgeMe(currentMain);
  }

  reinitJudgeMe(container) {
    // Re-execute the inline data script that sets jdgm.data.reviewWidget[productId]
    container.querySelectorAll('.shopify-app-block script').forEach(function(oldScript) {
      if (oldScript.src) return;
      if (oldScript.textContent.indexOf('jdgm.data') === -1) return;
      var newScript = document.createElement('script');
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    // Reset Judge.me state so the widget can be re-processed
    if (typeof jdgm !== 'undefined') {
      jdgm._loaderExecuted = false;
    }
    container.querySelectorAll('.jdgm--done-setup-widget').forEach(function(el) {
      el.classList.remove('jdgm--done-setup-widget');
    });

    // Judge.me's review_widget.js is an ES module with a singleton that
    // checks `this.initialized`. Dynamic import with a cache-busting param
    // creates a fresh module instance that re-processes the widget.
    var entryScript = document.querySelector('script[src*="review_widget"]');
    if (entryScript) {
      var baseUrl = entryScript.src.split('?')[0];
      import(baseUrl + '?v=' + Date.now()).catch(function() {});
    }
  }

  replaceSections(newDoc) {
    var currentMain = document.getElementById('MainContent');
    var newMain = newDoc.getElementById('MainContent');
    if (!currentMain || !newMain) return;

    var newChildren = [];
    while (newMain.firstChild) {
      newChildren.push(document.adoptNode(newMain.firstChild));
    }

    currentMain.replaceChildren.apply(currentMain, newChildren);

    currentMain.querySelectorAll('.scroll-trigger').forEach(function(el) {
      el.classList.add('scroll-trigger--cancel');
    });

    this.reinitJudgeMe(currentMain);
  }

  activateInlineScripts() {
    this.activateInlineScriptsIn(document.getElementById('MainContent'));
  }

  activateInlineScriptsIn(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach(function(oldScript) {
      if (oldScript.src) return;
      if (oldScript.type && oldScript.type !== 'text/javascript' && oldScript.type !== '') return;

      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function(attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  reinitialize(newHandle) {
    this.currentHandle = newHandle;

    var newSelector = document.querySelector('[data-product-family-selector]');
    if (newSelector) {
      new ProductFamilySelector(newSelector);
    }

    if (window.Shopify && window.Shopify.PaymentButton) {
      try { window.Shopify.PaymentButton.init(); } catch (e) {}
    }

    if (typeof jdgm !== 'undefined') {
      try {
        if (jdgm.customWidgets) jdgm.customWidgets();
      } catch (e) {}
    }

    if (window.looxReviews) {
      try { window.looxReviews.init(); } catch (e) {}
    }

    document.querySelectorAll('#MainContent .shopify-section').forEach(function(section) {
      try {
        section.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: section.id.replace('shopify-section-', '') }
        }));
      } catch (e) {}
    });
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('[data-product-family-selector]');
  if (container) {
    new ProductFamilySelector(container);
  }
});

// Preload sibling products after the page has fully loaded and is idle
window.addEventListener('load', function() {
  var schedule = window.requestIdleCallback || function(cb) { setTimeout(cb, 1000); };
  schedule(function() {
    var container = document.querySelector('[data-product-family-selector]');
    if (container && container._pfsInstance) {
      container._pfsInstance.preloadFamilyProducts();
    }
  });
});

// Re-initialize when customizer reloads a section
document.addEventListener('shopify:section:load', function(event) {
  var container = event.target.querySelector('[data-product-family-selector]');
  if (container) {
    new ProductFamilySelector(container);
  }
});

// Handle browser back/forward after a product switch
window.addEventListener('popstate', function(event) {
  if (event.state && event.state.productHandle) {
    window.location.reload();
  }
});
